import { domToPng as modernDomToPng } from 'modern-screenshot'

export const SHARE_CARD_WIDTH = 1080
export const SHARE_CARD_HEIGHT = 1920

export interface CaptureElementToPngOptions {
  width?: number
  height?: number
  pixelRatio?: number
}

export async function captureElementToPng(
  element: HTMLElement,
  options: CaptureElementToPngOptions = {}
): Promise<Blob> {
  const width = options.width ?? SHARE_CARD_WIDTH
  const height = options.height ?? SHARE_CARD_HEIGHT
  const scale = options.pixelRatio ?? 2

  const dataUrl = await modernDomToPng(element, {
    width,
    height,
    scale,
  })

  const response = await fetch(dataUrl)
  const blob = await response.blob()
  if (!blob.type.startsWith('image/')) {
    return new Blob([blob], { type: 'image/png' })
  }
  return blob
}

export function downloadPngBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.rel = 'noopener'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 1000)
}

